import { AmplitudeEvent } from "./AmplitudeEvents";

const ENGINEERING_EVENT_NAME = "engineering_insight";

export const EngineeringInsightType = {
    MISSING_RESIZE_OBSERVER: "missing_resize_observer",
    FRIGADE_API_DEGRADED: "frigade_api_degraded",
} as const;
export type EngineeringInsightType = (typeof EngineeringInsightType)[keyof typeof EngineeringInsightType];

/**
 * Amplitude event to provide engineering insights (as opposed to product insights) .
 */
export class AmplitudeEngineeringInsightEvent extends AmplitudeEvent {
    constructor(
        public type: EngineeringInsightType,
        public description: string,
        props: Record<string, unknown>,
    ) {
        super(ENGINEERING_EVENT_NAME);
        this.props = {
            type,
            ...props,
        };
    }
}

export class AmplitudeMissingResizeObserverEvent extends AmplitudeEngineeringInsightEvent {
    constructor() {
        super(
            EngineeringInsightType.MISSING_RESIZE_OBSERVER,
            "Safari browser only started supporting ResizeObserver API from version 13.1. " +
                "There are some users using older versions of Safari, " +
                "but the global error events about missing ResizeObserver only started happening around Apr 17th. " +
                "This event is to figure out why it started happening so suddenly.",
            {},
        );
    }
}
